import React, { Suspense, lazy } from 'react';
import { ActivityLogger } from '../lib/activityLogger.js';

const Header = lazy(() => import('../components/Header.jsx'));
const HomeActivityDashboard = lazy(() => import('../components/HomeActivityDashboard.jsx'));

export default function ActivityDashboardPage() {
  // Log page view on mount
  React.useEffect(() => {
    ActivityLogger.pageView('Activity Dashboard Page', '/activity-dashboard');
  }, []);

  return (
    <div className="container" style={{ marginTop: 0, paddingTop: 0 }}>
      <Suspense fallback={<div style={{ textAlign: 'center', padding: 24, color: '#bdbdbd' }}>Loading...</div>}>
        <Header />
      </Suspense>

      {/* Activity Dashboard Section */}
      <Suspense fallback={
        <div style={{ textAlign: 'center', padding: 60, color: '#888' }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>⏳</div>
          <p>Loading activity dashboard...</p>
        </div>
      }>
        <HomeActivityDashboard />
      </Suspense>
    </div>
  );
}
